import { render } from "./ListeMonnaiePage.vue?vue&type=template&id=0cffb78d&ts=true"
import script from "./ListeMonnaiePage.vue?vue&type=script&lang=ts"
export * from "./ListeMonnaiePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__